import { scrollToJoinSection } from "@/lib/scroll-to-join";

export default function B2BHeroSection() {
  function scrollToForm() {
    scrollToJoinSection();
  }

  return (
    <section className="flex flex-col items-start gap-6 animate-[fade-in_0.5s_ease-out]">
      <span className="text-white/60 text-xs font-semibold tracking-[0.15em] uppercase">
        Skill Up, Scale Up
      </span>

      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between w-full gap-6">
        <h1 className="font-fira-condensed text-4xl sm:text-5xl font-bold tracking-tight text-white leading-[1.1] animate-[fade-in_0.5s_ease-out_0.1s_both]">
          Upskill your Team;
          <br />
          Upscale your Business
        </h1>

        <button
          type="button"
          onClick={scrollToForm}
          className="shrink-0 bg-white text-black rounded-full px-6 py-3 text-sm font-semibold hover:opacity-90 transition-opacity cursor-pointer animate-[fade-in_0.5s_ease-out_0.2s_both] whitespace-nowrap"
        >
          Get Started
        </button>
      </div>

      <p className="text-secondary text-base sm:text-lg max-w-2xl leading-relaxed animate-[fade-in_0.5s_ease-out_0.2s_both]">
        Empower your team to master AI, unlock productivity, and drive
        continuous innovation that propels sustained business growth.
      </p>

      <div className="h-px w-full bg-gradient-to-r from-white/10 via-white/5 to-transparent mt-2 animate-[fade-in_0.5s_ease-out_0.3s_both]" />
    </section>
  );
}
